export default function Installation () {
    return (
        <div>
        <h2>Installation</h2>
        <div className="mb-2 divider" />
        <p>
          The DISGENET Cytoscape App is available from the Cytoscape App Store:
          <a href="https://apps.cytoscape.org/apps/disgenetapp" target="_blank" rel="noreferrer">
            {' '}
            https://apps.cytoscape.org/apps/disgenetapp
          </a>
        </p>
      </div>
    )
}